import { Component, Input, OnInit, Output, EventEmitter, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import { SelectionModel } from '@angular/cdk/collections';
import { MatLegacyCheckboxChange as MatCheckboxChange } from '@angular/material/legacy-checkbox';
import { Subject } from 'rxjs';
import { DirectOfferItem } from './direct-offer-create-margin-item.model';

@Component({
    selector: 'nova-direct-offer-create-quote-margin',
    templateUrl: './direct-offer-create-margin-table.component.html'
})
export class DirectOfferCreateMarginTableComponent implements OnInit, OnChanges, OnDestroy {
    displayedColumns: string[] = [
        'select',
        'targetMargin',
        'marginPct',
        'relocation',
        'ayaHousing',
        'weeklyPay',
        'equal',
        'taxable',
        'facility',
        'housingCost',
        'jobTitle',
        'shift'
    ];
    selection = new SelectionModel<DirectOfferItem>(true, []);

    @Input()
    data: DirectOfferItem[];

    @Output()
    rowChecked = new EventEmitter();

    @Output()
    quoteUpdated = new EventEmitter<DirectOfferItem[]>();

    private readonly _destroy$ = new Subject();

    ngOnInit(): void {
        if (this.data && this.data.length > 0) {
            this.quoteUpdated.emit(this.data);
        }

        this.selection.changed.subscribe(() => this.rowChecked.emit(this.selection.selected));
    }

    ngOnChanges(directOfferChanges: SimpleChanges): void {
        if (directOfferChanges && directOfferChanges.data && directOfferChanges.data.currentValue) {
            this.data = directOfferChanges.data.currentValue.map((item: DirectOfferItem) => {
                item['relocation'] = item['relocation'] || 0;
                item['ayaHousing'] = item['ayaHousing'] || false;
                item['nonTaxable'] = item['nonTaxable'] || 0;
                item['marginPct'] = item['marginPct'] || 0;
                item['taxable'] = item['taxable'] || 0;
                item['weeklyPay'] = item['weeklyPay'] || 0;
                item['altWeeklyPay'] = item['altWeeklyPay'] || 0;
                item['taxableAltPay'] = item['taxableAltPay'] || 0;
                item['nonTaxableAltPay'] = item['nonTaxableAltPay'] || 0;
                item['targetMargin'] = item['targetMargin'] || 0;
                return item;
            });
        }
    }

    ngOnDestroy(): void {
        this._reset();
        this._destroy$.next(true);
        this._destroy$.complete();
    }

    relocationChanged(row: DirectOfferItem, amount: number): void {
        if (amount > -1) {
            this.data = this.data.map((value: DirectOfferItem) => {
                if (value.id === row.id) {
                    value['relocation'] = amount;
                }

                return value;
            });

            this.quoteUpdated.emit(this.data);
        }
    }

    selectAyaHousing(row: DirectOfferItem, needHousing: MatCheckboxChange): void {
        this.data = this.data.map((value: DirectOfferItem) => {
            if (value.id === row.id) {
                value['ayaHousing'] = needHousing.checked;
            }

            return value;
        });

        this.quoteUpdated.emit(this.data);
    }

    marginPctChanged(row: DirectOfferItem, amount: number): void {
        if (amount > -1) {
            this.data = this.data.map((value: DirectOfferItem) => {
                if (value.id === row.id) {
                    value['marginPct'] = amount;
                }

                return value;
            });

            this.quoteUpdated.emit(this.data);
        }
    }

    private _reset(): void {
        if (this.data) {
            this.data = this.data.map((value: DirectOfferItem) => {
                value['relocation'] = 0;
                value['ayaHousing'] = false;
                value['nonTaxable'] = 0;
                value['marginPct'] = 0;
                value['taxable'] = 0;
                value['weeklyPay'] = 0;
                value['altWeeklyPay'] = 0;
                value['taxableAltPay'] = 0;
                value['nonTaxableAltPay'] = 0;
                return value;
            });
        }
    }
}
